import { all } from "redux-saga/effects";

import {
  watchFetchPDPInitSaga,
  watchFetchBidDetailsSaga,
  watchFetchLatestBidDetailsSaga,
} from "./PDP/pdpSaga";

import { watchFetchSupportSaga } from "./SUPPORT/supportSaga";
import {
  watchFetchSRPInitSaga,
  watchFetchAutocompleteSaga,
} from "./SRP/srpSaga";
import { watchFetchSRPFilterInitSaga } from "./SRP/srpFilterSaga";
import { watchRecentSearchesSaga } from "./SRP/recentSearchSaga";
import { watchSavedSearchesSaga } from "./SRP/savedSearchSaga";
import watchOtpModalSaga from "./otpModal/otpModalSaga";
import { watchCmsSaga } from "./cms/cmsSaga";

export default function* rootSaga() {
  yield all([
    watchFetchSupportSaga(),
    watchFetchPDPInitSaga(),
    watchFetchSRPInitSaga(),
    watchFetchAutocompleteSaga(),
    watchFetchBidDetailsSaga(),
    watchFetchLatestBidDetailsSaga(),
    watchFetchSRPFilterInitSaga(),
    watchRecentSearchesSaga(),
    watchSavedSearchesSaga(),
    watchOtpModalSaga(),
    watchCmsSaga()
  ]);
}
